module.exports = __webpack_public_path__ + "img/99.5.d20b732d.png";